module.exports = {
      id: "credit-card-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#credit-card-icon",
      toString: function () {
        return this.url;
      }
    }